export default __webpack_public_path__ + "static/media/Lisa Gillmor.4bd28e58.jpg";